export default __webpack_public_path__ + "static/media/LeadBrix@4x.9c0ce31f.png";